<template>
  <div class="compound public-content">
    <div class="breadcrumb">满减活动</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0">SKU名称:</span>
        <el-input v-model="rulesVO.skuName"></el-input>
        <span style="margin:0 10px 0 15px">产品名称:</span>
        <el-input v-model="rulesVO.spuName"></el-input>

      </div>
      <div>
        <el-button round @click="queryInfo.pageNum=1,onSubmit()">查询</el-button>
        <el-button round @click="$router.push('/MoneyOffNew')" type="primary">新建满减活动</el-button>
      </div>
    </div>

    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="SKU名称" prop="skuName"></el-table-column>
          <el-table-column label="产品名称" prop="spuName"></el-table-column>
          <el-table-column label="SKU组名称" prop="skuGroupName"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" @click="edit(scope)">编辑</span><br>
              <span class="color-blue" @click="deleteId=scope.row.id,deleteDialog=true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该满减活动？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="del(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index'
import { skuDiscountRuleList, skuDiscountRuleDelete } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      rulesVO: {
        skuName: '',
        spuName: ''
      }
    }
  },
  created () {
    this.onSubmit()
  },
  methods: {
    del (id) {
      skuDiscountRuleDelete(id)
        .then(res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.onSubmit()
            this.deleteDialog = false
          }
        })
    },
    edit (scope) {
      this.$router.push({
        path: '/MoneyOffNew',
        query: {
          id: scope.row.id
        }
      })
    },
    onSubmit () {
      skuDiscountRuleList({
        pageNum: this.queryInfo.pageNum,
        pageSize: this.queryInfo.pageSize,
        data: this.rulesVO
      })
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.records
            this.queryInfo.total = res.data.data.total
          }
        })
    },

    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
 <style scoped lang="less">
.compound {
  .add-category {
    justify-content: space-between;
  }
  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;
    .el-input {
      width: 180px;
    }
  }
}
</style>
